import { useState, useEffect } from 'react'
import { Box, Link, List, ListItem, ListItemButton, Typography } from '@mui/material'
import { useStyles } from './style'

const navItems = [
  { label: 'About', href: '#about', sectionId: 'about' },
  { label: 'FAQs', href: '#faqs', sectionId: 'faqs' },
  { label: 'Event Resources', href: '#resources', sectionId: 'resources' },
  { label: 'Quick How-Tos', href: '#how-to', sectionId: 'how-to' },
  { label: 'Contact Us', href: '#contact-us', sectionId: 'contact-us' },
]

const linkBlue = '#4a6fa5' // Calmer blue for anchor links

export function SupportPageNav() {
  const classes = useStyles()
  const [activeSection, setActiveSection] = useState<string | null>(null)

  useEffect(() => {
    const sectionIds = navItems.map((item) => item.sectionId)
    const observers: IntersectionObserver[] = []

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id
            if (id) setActiveSection(id)
          }
        })
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: 0 }
    )

    sectionIds.forEach((id) => {
      const el = document.getElementById(id)
      if (el) {
        observer.observe(el)
        observers.push(observer)
      }
    })

    return () => observer.disconnect()
  }, [])

  return (
    <Box
      component="nav"
      aria-label="Support page navigation"
      className={classes.supportPageNav}
      sx={{
        position: 'sticky',
        top: 100,
        alignSelf: 'flex-start',
        display: { xs: 'none', md: 'block' },
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        On this page
      </Typography>
      <List disablePadding>
        {navItems.map(({ label, href, sectionId }) => (
          <ListItem key={href} disablePadding sx={{ mb: 0.5 }}>
            <ListItemButton
              component={Link}
              href={href}
              sx={{
                py: 0.5,
                px: 0,
                pl: 1,
                textDecoration: 'none',
                color: linkBlue,
                borderLeft: '3px solid transparent',
                ...(activeSection === sectionId && {
                  borderLeftColor: 'primary.main',
                  fontWeight: 600,
                }),
                '&:hover': {
                  color: 'primary.main',
                  backgroundColor: 'transparent',
                  textDecoration: 'underline',
                },
              }}
            >
              <Typography variant="body2">{label}</Typography>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  )
}
